import React from 'react';
import Grid from '@mui/material/Grid';
import CustomTextInput from '../CustomTextInput';
import { cardPaymentCodes, paymentFinancialAccountCodes, paymentMandateCodes } from '../../constants/appConstants';

const PaymentMeansFields = ({ control, errors, readOnly, watchedPaymentMeans, setValue, disabled }) => {
  return (
    <>
      {cardPaymentCodes.includes(watchedPaymentMeans.payment_means_code) && (
        <>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <CustomTextInput
              data-testid="primary_account_number_id-input"
              name="payment_means.card_account.primary_account_number_id"
              control={control}
              errors={errors}
              readOnly={readOnly}
              label={'PAN'}
              disabled={disabled}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <CustomTextInput
              data-testid="network_id-input"
              name="payment_means.card_account.network_id"
              control={control}
              errors={errors}
              readOnly={readOnly}
              label={'Network ID'}
              disabled={disabled}
            />
          </Grid>
        </>
      )}

      {paymentFinancialAccountCodes.includes(watchedPaymentMeans.payment_means_code) && (
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <CustomTextInput
            data-testid="payeeFinancialAccount-input"
            name="payment_means.payee_financial_account.id"
            control={control}
            errors={errors}
            readOnly={readOnly}
            label={'Payment account identifier'}
            disabled={disabled}
          />
        </Grid>
      )}

      {paymentMandateCodes.includes(watchedPaymentMeans.payment_means_code) && (
        <>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <CustomTextInput
              data-testid="payment_mandate-input"
              name="payment_means.payment_mandate.id"
              control={control}
              errors={errors}
              readOnly={readOnly}
              label="Mandate reference Identifier"
              disabled={disabled}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <CustomTextInput
              data-testid="payer_financial_account_id"
              name="payment_means.payment_mandate.payer_financial_account_id"
              control={control}
              errors={errors}
              readOnly={readOnly}
              label="Payer Financial Account Identifier"
              disabled={disabled}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default PaymentMeansFields;
